<template>
  <div class="w-full h-full absolute bg-black/50 text-center md:py-4">
    <div
      v-if="editablePolls.length > 0"
      ref="popup"
      class="bg-white md:rounded-lg md:w-5/6 inline-block w-full relative text-left max-h-full overflow-auto"
    >
      <font-awesome-icon
        icon="xmark"
        class="text-3xl text-primary cursor-pointer float-right m-3"
        @click="$emit('close')"
      />

      <template v-for="(poll, index) in editablePolls" :key="poll.id">
        <!-- Group header when group changes -->
        <div
          v-if="poll.umfragegruppe && (index === 0 || editablePolls[index - 1].umfragegruppe?.id !== poll.umfragegruppe.id)"
          class="text-2xl font-bold mb-3 px-4 mt-4"
        >{{ poll.umfragegruppe.title }}</div>

        <div class="mb-4 border rounded-lg p-4 shadow-sm" :class="poll.umfragegruppe ? 'mx-4' : ''">
          <span class="font-semibold" :class="poll.umfragegruppe ? 'text-lg' : 'text-2xl'">{{ poll.title }}</span>

          <pre class="whitespace-break-spaces font-sans text-left w-full">{{ poll.description }}</pre>

          <p v-if="poll.multiple" class="text-sm text-gray-500 mb-2">{{ $t('Mehrfachauswahl möglich') }}</p>

          <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
            <div
              v-for="option in poll.options" :key="option.id"
              class="flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:bg-gray-50 mb-2"
              :class="{ 'bg-blue-50 border-blue-300': (!poll.multiple && poll.answer === option.id) || (poll.multiple && option.selected) }"
              @click="selectOption(poll, option)"
            >
              <label :for="poll.id + '_' + option.id" class="flex items-center gap-3 cursor-pointer flex-1" @click.stop>
                <input
                  :type="poll.multiple ? 'checkbox' : 'radio'"
                  :id="poll.id + '_' + option.id"
                  :name="poll.title"
                  v-model="option.selected"
                  v-if="poll.multiple"
                />
                <input
                  type="radio"
                  :id="poll.id + '_' + option.id"
                  :name="poll.title"
                  :value="option.id"
                  :checked="poll.answer === option.id"
                  @change="selectOption(poll, option)"
                  v-else
                />
                <span v-if="!option.freetext">{{ option.answer }}</span>
              </label>
              <input v-if="option.freetext" v-model="poll.freetext" class="w-auto py-1" type="text" :placeholder="$t('Freitext')" @click.stop @input="onFreetextInput(poll, option)" />
            </div>
          </div>

          <div v-if="poll.comments">
            <label>{{ $t('Kommentar') }}</label>
            <input type="text" v-model="poll.comment" :placeholder="$t('Kommentar eingeben...')" />
          </div>
        </div>
      </template>

      <div class="w-full text-center">
        <button class="green my-4" @click="saveAnswers()">{{ $t('Speichern') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import API from "@/API";

export default {
  emits: ["toast", "close"],
  props: {
    polls: Array,
    contract:Object
  },

  data() {
    return {
      editablePolls: [],
    };
  },
  methods: {
    selectOption(poll, option) {
      if (poll.multiple) {
        if (!option.freetext) {
          option.selected = option.selected ? false : 'on';
        }
      } else {
        poll.answer = option.id;
        poll.freetext = ""; // Clear freetext when selecting an option
      }
    },
    onFreetextInput(poll, option) {
      const hasContent = poll.freetext && poll.freetext.trim() !== "";
      if (poll.multiple) {
        option.selected = hasContent ? 'on' : false;
      } else {
        poll.answer = hasContent ? option.id : null;
      }
    },
    saveAnswers() {
      let polls = {};
      this.editablePolls.forEach((poll) => {
        polls[poll.id] = {
          answers: [],
          comment: poll.comment,
        };
        if (!poll.multiple) {
          // Don't set answer if the selected option is the freetext option
          const selectedOption = poll.options.find(o => o.id === poll.answer);
          if (!selectedOption || !selectedOption.freetext) {
            polls[poll.id].answer = poll.answer;
          }
        }
        if (poll.freetext) {
          polls[poll.id].freetext = poll.freetext;
        }
        poll.options.forEach((option) => {
          if (poll.multiple) {
            if (option.selected && !option.freetext) {
              polls[poll.id].answers.push(option.id);
            }
          }
        });
      });
      API.answerPolls(this.contract.id, polls, (r, status) => {
        if (status === 200) {
          this.$emit("toast", "Angaben gesendet!");
          this.$emit("close");
        }
      });
    },
  },
  mounted() {
    if (this.polls) {
      this.editablePolls = this.polls;
      this.editablePolls.forEach((poll) => {
        if (poll.options.length === 1) {
          const option = poll.options[0];
          if (poll.multiple) {
            if (!option.freetext) {
              option.selected = 'on';
            }
          } else {
            if (!option.freetext) {
              poll.answer = option.id;
            }
          }
        }
        if (poll.multiple) {
          poll.options.forEach((option) => {
            option.selected = poll.answers.includes(option.id)?'on':false;
            if (option.selected) {
              setTimeout(() => {
                document.getElementById(poll.id + "_" + option.id).checked =
                  option.selected;
              }, 500);
            }
          });
        } else if (poll.answers.length == 1) {
          poll.answer = poll.answers[0];
        }
      });
    }
  },
};
</script>
